import axios from 'axios';
import { useFormik } from 'formik';
import React, { useContext } from 'react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { AuthContxt } from '../AuthContext';
import adress from '../../Assets/images/location.jpg'
import { Cartcontext } from '../Cartcontext';

export default function Address() {
  let { cartId } = useParams()
  // console.log(cartId)
  const { setcart: ContextSetCart } = useContext(Cartcontext)
  const [errorMsg, seterrorMsg] = useState()
  const [isloading, setisloading] = useState()
  const { UserLoggedIn, setUserLoggedIn } = useContext(AuthContxt)
  const [cart, setcart] = useState({})

  const navigate = useNavigate()
  const validationSchema = yup.object({

    details: yup.string().required("details is required"),
    phone: yup.string().required("phone is required"),
    city: yup.string().required("city is required"),



  })


  async function ClearCart() {
    const { data } = await axios.delete('https://ecommerce.routemisr.com/api/v1/cart', { headers: { token: localStorage.getItem('token') } })
    setcart(data)
    ContextSetCart({})
  }
  const { values, handleSubmit, handleChange, errors, touched, handleBlur, isValid } = useFormik({
    initialValues: {
      details: '',
      phone: '',
      city: ''

    },
    onSubmit: async () => {
      try {
        let { data } = await axios.post(`https://ecommerce.routemisr.com/api/v1/orders/checkout-session/${cartId}`, {
          shippingAddress: values
        },
          {
            headers: { token: localStorage.getItem('token') }
          },
          {
            url: 'http://localhost:4200'
          }
        )
        console.log(data.session.url)
        window.open(data.session.url, "_self")
      } catch (error) {
        seterrorMsg(error.response.data.message)

      }
      setisloading(false)
    },

    validationSchema
  })

  return <>
    <div className="container">
      <div className='AuthDiv'>
        <div className="w-75 m-auto my-5 authoinner p-xl-5 p-3">

          <div className="row align-items-center">
            <div className="col-md-6">
              <form onSubmit={handleSubmit}>

                <label htmlFor="details" className='my-1'>details:</label>
                <input onChange={handleChange} value={values.details} type="text" className='form-control mb-3' id='details' name='details' />
                {errors.details && touched.details && <p className='alert alert-danger'>{errors.details}</p>}

                <label htmlFor="phone" className='my-1'>phone:</label>
                <input onChange={handleChange} onBlur={handleBlur} value={values.phone} type="tel" className='form-control mb-3' id='phone' name='phone' />
                {errors.phone && touched.phone && <p className='alert alert-danger'>{errors.phone}</p>}

                <label htmlFor="city" className='my-1'>city:</label>
                <input onChange={handleChange} onBlur={handleBlur} value={values.city} type="tel" className='form-control mb-3' id='city' name='city' />
                {errors.city && touched.city && <p className='alert alert-danger'>{errors.city}</p>}

                {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
                {isloading ? <button disabled type='button' className='btn bg-main px-3 text-white ms-auto d-block px-3'> <i className='fas fa-spin fa-spinner px-4'></i> </button>
                  :
                  <button type='submit' disabled={!isValid || isloading} className='btn bg-main px-3 text-white ms-auto d-block' onClick={ClearCart}>Pay Now</button>
                }

              </form>
            </div>
            <div className="col-md-6">
            <img src={adress} className='w-100' />

            </div>
          </div>

        </div>
      </div>
    </div>
  </>
}
